import { Box, ListItem } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleRight, faCircle, faCircleCheck } from '@fortawesome/pro-regular-svg-icons';

interface IStatusIconProps {
  children: React.ReactNode;
  isActive?: boolean;
  isComplete?: boolean;
}

export const CASTrackerItem: React.FC<IStatusIconProps> = (props: IStatusIconProps) => {
  const { children, isActive, isComplete } = props;

  const getProps = () => {
    if (isActive) {
      return { color: 'cyan.400', icon: faChevronCircleRight };
    } else if (isComplete) {
      return { color: 'green.400', icon: faCircleCheck };
    } else {
      return { color: 'extra-muted', icon: faCircle };
    }
  };

  return (
    <ListItem display="flex" mb={4} lineHeight={5} ml={0}>
      <Box as="span" color={getProps().color} mr={2}>
        <FontAwesomeIcon icon={getProps().icon} size="lg" fixedWidth />
      </Box>

      {children}
    </ListItem>
  );
};
